import { Injectable, signal } from '@angular/core'

import { Configuration } from '@definitions/guest-page-config'

@Injectable({
	providedIn: 'root',
})
export class TicketActionsState {
	readonly configuration = signal<Configuration | null>(null)
	readonly isCarRequested = signal(false)
	readonly expectedCheckout = signal<Date | null>(null)
}
